import React from 'react';
import styled, { keyframes } from 'styled-components';
import { ToastItem } from '../../hooks/useToast';

const slideIn = keyframes`
  from { transform: translateX(110%); opacity: 0; }
  to   { transform: translateX(0);    opacity: 1; }
`;

const Wrapper = styled.div`
  position: fixed;
  top: 24px;
  right: 24px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 8px;
  pointer-events: none;
`;

const Item = styled.div<{ type: 'success' | 'error' }>`
  padding: 12px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  color: white;
  animation: ${slideIn} 0.25s ease-out;
  background: ${({ type }) => type === 'success' ? '#10b981' : '#ef4444'};
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-width: 320px;
`;

const Toast: React.FC<{ toasts: ToastItem[] }> = ({ toasts }) => (
  <Wrapper>
    {toasts.map(t => (
      <Item key={t.id} type={t.type}>{t.message}</Item>
    ))}
  </Wrapper>
);

export default Toast;
